import Vue from 'vue'

let baseURL
//切换环境
if (process.env.NODE_ENV == 'development') {
    // baseURL = 'http://127.0.0.1:8082';
    // baseURL = 'http://dev.scjfu.com';
    baseURL = 'https://api.xmdch.com';
}
else if (process.env.NODE_ENV == 'debug') {
    baseURL = 'https://api.xmdch.com';
} 
else if (process.env.NODE_ENV == 'production') {
    baseURL = 'https://api.xmdch.com';
}
// console.log(process.env.NODE_ENV); // 打印结果为 'development'
Vue.prototype.$baseURL = baseURL


export default {
    baseURL
};
